// extracted by mini-css-extract-plugin
module.exports = {"containerError404":"Error404_containerError404__7hpAq","errorPage":"Error404_errorPage__1ZwFr","btnSize":"Error404_btnSize__1PTy7"};